<template>
  <div class="report-section">
    <h3 class="report-title">Event Reports</h3>

    <div class="report-table-container">
      <table class="report-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Report Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Registered Event Users</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportFile"></i>
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td>Login Event Users</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportLoginUserFile"></i>
            </td>
          </tr>
          <tr>
            <td>3</td>
            <td>Live Presentation Detail Analytics</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportLivePresentationDetailFile"></i>
            </td>
          </tr>
          <tr>
            <td>4</td>
            <td>Panel Discussions Detail Analytics</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportPanelDiscussionsDetailFile"></i>
            </td>
          </tr>

          <tr>
            <td>5</td>
            <td>Roundtable  Detail Analytics</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportRoundtableFile"></i>
            </td>
          </tr>

          <tr>
            <td>6</td>
            <td>On Demand  Detail Analytics</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportOnDemandFile"></i>
            </td>
          </tr>
           <tr>
            <td>7</td>
            <td>Exhibition/Booth Visitors Analytics</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportExhibitionBoothVisitorsFile"></i>
            </td>
          </tr>
          <tr>
            <td>8</td>
            <td>Event Assets Analytics</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportEventAssetsFile"></i>
            </td>
          </tr>

          <tr>
            <td>9</td>
            <td>Event Chat/Video Call Analytics</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportEventChatVideoCallFile"></i>
            </td>
          </tr>

            <tr>
            <td>10</td>
            <td>Meetings Analytics</td>
            <td>
              <i class="bx bx-download download-icon" @click="exportMeetingsFile"></i>
            </td>
          </tr>
          <tr>
          <td>11</td>
          <td>Consolidated Event Journey Report</td>
          <td>
            <i class="bx bx-download download-icon" @click="exportConsolidatedReport"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)


import {
mapGetters,
mapActions
} from 'vuex'
import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
import TogglePrimary from "@/components/Commons/TogglePrimary";
import _ from "lodash";
import BackButton from "@/components/Commons/BackButton";

import { isPermits} from "@/services/CheckPermissions";
import headerForm from "@/components/cruds/EventAnalytics/Forms/Header";
import TabForm from "@/components/cruds/EventAnalytics/Forms/TabEventHall";
import { ref } from "vue";
import { utils, writeFileXLSX } from 'xlsx';

export default {
name: 'LpIndex',
components: {
   
},
data() {
return {
    search: null,
    perPage: 5,
    system_users: [],
   }
},
watch: {
},
created() {


},
beforeUnmount() {
//this.resetState();
//delete this.$flashMessage.groups.event_assets_index;

},
computed: {
...mapGetters('EventAnalyticsIndex', ['loading', 'all', 'headers','enumModules','loaded','chartEventHall']),
},
methods: {
...mapActions('EventAnalyticsIndex', ['onChangeEventHallData','onChangefetchData','fetchData','resetState','generateSheet','generateLivePresentationsSheet']),
createClick() {
    this.setIsNew(true);
    this.setIsEditing(false);
},
cancelClick() {
    this.resetState();
},
perRowChange(e) {
    this.perPage = Number(e.target.value);
},

async exportFile() {
    let event_users                 = [];
    let evennt_loggin_user          = [];
    let postData = {eventId :this.$route.params.event_id, event_type:'Event-Users'}
    let response = await this.generateSheet(postData);
    if(response.data.data){
        event_users                     = response.data.data.event_users;
        evennt_loggin_user              = response.data.data.event_login_users;
    }
    /* generate worksheet from state */
     const ws = utils.json_to_sheet(event_users);
     const ws1 = utils.json_to_sheet(evennt_loggin_user);
  
    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Event Users");
    utils.book_append_sheet(wb, ws1, "Event Loggin Users");
    /* export to XLSX */
    writeFileXLSX(wb, "EventUsers_Analytics.xlsx");
},

async exportLoginUserFile() {
    let event_users                 = [];
    let evennt_loggin_user          = [];
    let postData = {eventId :this.$route.params.event_id, event_type:'Event-Users'}
    let response = await this.generateSheet(postData);
    console.log("Response Login Users",response);
    if(response.data.data){
        evennt_loggin_user              = response.data.data.event_login_users;
    }
    /* generate worksheet from state */
     const ws = utils.json_to_sheet(evennt_loggin_user);
     
    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Event Loggin Users");
    /* export to XLSX */
    writeFileXLSX(wb, "EventUsers_LoginAnalytics.xlsx");
},
async exportLivePresentationDetailFile(){
    let sheet_session   = [];
                let sheet_qa        = [];
                let sheet_polling   = [];
                let sheet_rating    = []

                let response = await this.generateLivePresentationsSheet(this.$route.params.event_id);
                if(response.data.data){
                    sheet_session       = response.data.data.session_analytics;
                    sheet_qa            = response.data.data.qa_participant;
                    sheet_polling       = response.data.data.polling_participant;
                    sheet_rating        = response.data.data.rating_participant;

                }
                /* generate worksheet from state */
                 const ws = utils.json_to_sheet(sheet_session);
                 const ws1 = utils.json_to_sheet(sheet_qa);
                 const ws2 = utils.json_to_sheet(sheet_polling);
                 const ws3 = utils.json_to_sheet(sheet_rating);
             
                /* create workbook and append worksheet */
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, "Session Analytics");
                utils.book_append_sheet(wb, ws1, "Q&A Participants");
                utils.book_append_sheet(wb, ws2, "Polling Participants");
                utils.book_append_sheet(wb, ws3, "Rating Participants");
                /* export to XLSX */
                writeFileXLSX(wb, "Live_Presentation_Analytics.xlsx");

},
async exportPanelDiscussionsDetailFile(){
     let sheet_session   = [];
     let sheet_qa        = [];
     let sheet_polling   = [];
     let sheet_rating    = []
     let postData = {eventId :this.$route.params.event_id, event_type:'Panel-Discussions'}
     let response = await this.generateSheet(postData);
     if(response.data.data){
         sheet_session       = response.data.data.session_analytics;
         sheet_qa            = response.data.data.qa_participant;
         sheet_polling       = response.data.data.polling_participant;
         sheet_rating        = response.data.data.rating_participant;

     }
     /* generate worksheet from state */
      const ws = utils.json_to_sheet(sheet_session);
      const ws1 = utils.json_to_sheet(sheet_qa);
      const ws2 = utils.json_to_sheet(sheet_polling);
      const ws3 = utils.json_to_sheet(sheet_rating);
  
     /* create workbook and append worksheet */
     const wb = utils.book_new();
     utils.book_append_sheet(wb, ws, "Session Analytics");
     utils.book_append_sheet(wb, ws1, "Q&A Participants");
     utils.book_append_sheet(wb, ws2, "Polling Participants");
     utils.book_append_sheet(wb, ws3, "Rating Participants");
     /* export to XLSX */
     writeFileXLSX(wb, "Panel_Discussions_Analytics.xlsx");
},
async exportRoundtableFile() {
     let sheet_session   = [];
     let sheet_qa        = [];
     let sheet_polling   = [];
     let sheet_rating    = []
     let postData = {eventId :this.$route.params.event_id, event_type:'RoundTable'}
     let response = await this.generateSheet(postData);
     if(response.data.data){
         sheet_session       = response.data.data.session_analytics;
         sheet_qa            = response.data.data.qa_participant;
         sheet_polling       = response.data.data.polling_participant;
         sheet_rating        = response.data.data.rating_participant;

     }
     /* generate worksheet from state */
      const ws = utils.json_to_sheet(sheet_session);
      const ws1 = utils.json_to_sheet(sheet_qa);
      const ws2 = utils.json_to_sheet(sheet_polling);
      const ws3 = utils.json_to_sheet(sheet_rating);
  
     /* create workbook and append worksheet */
     const wb = utils.book_new();
     utils.book_append_sheet(wb, ws,    "Session Analytics");
     utils.book_append_sheet(wb, ws1,   "Notes Participants");
     utils.book_append_sheet(wb, ws2,   "Polling Participants");
     utils.book_append_sheet(wb, ws3,   "Rating Participants");
     /* export to XLSX */
     writeFileXLSX(wb, "Roundtable_Analytics.xlsx");
},
async exportOnDemandFile() {
   let sheet_session   = [];
    let sheet_qa        = [];
    let sheet_polling   = [];
    let sheet_rating    = []
    let postData = {eventId :this.$route.params.event_id, event_type:'OnDemand'}
    let response = await this.generateSheet(postData);
    if(response.data.data){
        sheet_session       = response.data.data.session_analytics;
        sheet_qa            = response.data.data.qa_participant;
        sheet_polling       = response.data.data.polling_participant;
        sheet_rating        = response.data.data.rating_participant;
    }
    /* generate worksheet from state */
     const ws = utils.json_to_sheet(sheet_session);
     const ws1 = utils.json_to_sheet(sheet_qa);
     const ws2 = utils.json_to_sheet(sheet_polling);
     const ws3 = utils.json_to_sheet(sheet_rating);
 
    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Session Analytics");
    utils.book_append_sheet(wb, ws1, "Q&A Participants");
    utils.book_append_sheet(wb, ws2, "Polling Participants");
    utils.book_append_sheet(wb, ws3, "Rating Participants");
    /* export to XLSX */
    writeFileXLSX(wb, "Agenda_On_Demand_Analytics.xlsx"); 
},
async exportExhibitionBoothVisitorsFile() {
     let sheet_session   = [];
    let postData = {eventId :this.$route.params.event_id, event_type:'Exhibition-Area'}
    let response = await this.generateSheet(postData);
    if(response.data.data){
        sheet_session       = response.data.data.session_analytics;
  
    }
    /* generate worksheet from state */
     const ws = utils.json_to_sheet(sheet_session);
  
    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Booth Session Analytics");
        /* export to XLSX */
    writeFileXLSX(wb, "ExhibitionArea_Analytics.xlsx");
},
async exportEventAssetsFile(){
    let sheet_session   = [];
    let postData = {eventId :this.$route.params.event_id, event_type:'Event-Downloads'}
    let response = await this.generateSheet(postData);
    if(response.data.data){
        sheet_session       = response.data.data.session_analytics;

    }
    /* generate worksheet from state */
        const ws = utils.json_to_sheet(sheet_session);

    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Event Download Analytics");
        /* export to XLSX */
    writeFileXLSX(wb, "EventDownload_Analytics.xlsx");
},
async exportEventChatVideoCallFile(){
    let chat_sheet              = [];
    let video_call_sheet        = [];
    let postData = {eventId :this.$route.params.event_id, event_type:'Chats'}
    let response = await this.generateSheet(postData);
    if(response.data.data){
        chat_sheet              = response.data.data.chat;
        video_call_sheet        = response.data.data.video_call;

    }
    /* generate worksheet from state */
     const ws = utils.json_to_sheet(chat_sheet);
     const ws1 = utils.json_to_sheet(video_call_sheet);
    
    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Chat Analytics");
    utils.book_append_sheet(wb, ws1, "Video Call Participants");
    /* export to XLSX */
    writeFileXLSX(wb, "Chat_Analytics.xlsx");
},
async exportMeetingsFile() {
    let sheet_session   = [];
    let postData = {eventId :this.$route.params.event_id, event_type:'Meetings'}

    let response = await this.generateSheet(postData);
    if(response.data.data){
        sheet_session       = response.data.data.session_analytics;

    }
    /* generate worksheet from state */
      const ws = utils.json_to_sheet(sheet_session);
  
    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Session Analytics");
    /* export to XLSX */
    writeFileXLSX(wb, "Meetings_Analytics.xlsx");
},
async exportConsolidatedReport() {

        const eventId = this.$route.params.event_id;

        const wb = utils.book_new(); // Master Workbook

        // 1) Event Users
        let resUsers = await this.generateSheet({ eventId, event_type: 'Event-Users' });
        if (resUsers?.data?.data) {
          utils.book_append_sheet(wb, utils.json_to_sheet(resUsers.data.data.event_users), "Event Users");
          utils.book_append_sheet(wb, utils.json_to_sheet(resUsers.data.data.event_login_users), "Event Login Users");
        }

        // 2) Live Presentations
        let resLP = await this.generateLivePresentationsSheet(eventId);
        if (resLP?.data?.data) {
          utils.book_append_sheet(wb, utils.json_to_sheet(resLP.data.data.session_analytics), "LP Session Analytics");
          utils.book_append_sheet(wb, utils.json_to_sheet(resLP.data.data.qa_participant), "LP QA");
          utils.book_append_sheet(wb, utils.json_to_sheet(resLP.data.data.polling_participant), "LP Polling");
          utils.book_append_sheet(wb, utils.json_to_sheet(resLP.data.data.rating_participant), "LP Rating");
        }

        // 3) Panel Discussions
        let resPanel = await this.generateSheet({ eventId, event_type: 'Panel-Discussions' });
        if (resPanel?.data?.data) {
          utils.book_append_sheet(wb, utils.json_to_sheet(resPanel.data.data.session_analytics), "Panel Session Analytics");
          utils.book_append_sheet(wb, utils.json_to_sheet(resPanel.data.data.qa_participant), "Panel QA");
          utils.book_append_sheet(wb, utils.json_to_sheet(resPanel.data.data.polling_participant), "Panel Polling");
          utils.book_append_sheet(wb, utils.json_to_sheet(resPanel.data.data.rating_participant), "Panel Rating");
        }

        // 4) Roundtable
        let resRT = await this.generateSheet({ eventId, event_type: 'RoundTable' });
        if (resRT?.data?.data) {
          utils.book_append_sheet(wb, utils.json_to_sheet(resRT.data.data.session_analytics), "RT Session Analytics");
          utils.book_append_sheet(wb, utils.json_to_sheet(resRT.data.data.polling_participant), "RT Polling");
          utils.book_append_sheet(wb, utils.json_to_sheet(resRT.data.data.rating_participant), "RT Rating");
        }

        // 5) OnDemand
        let resOD = await this.generateSheet({ eventId, event_type: 'OnDemand' });
        if (resOD?.data?.data) {
          utils.book_append_sheet(wb, utils.json_to_sheet(resOD.data.data.session_analytics), "OnDemand Sessions");
          utils.book_append_sheet(wb, utils.json_to_sheet(resOD.data.data.qa_participant), "OnDemand QA");
          utils.book_append_sheet(wb, utils.json_to_sheet(resOD.data.data.polling_participant), "OnDemand Polling");
          utils.book_append_sheet(wb, utils.json_to_sheet(resOD.data.data.rating_participant), "OnDemand Rating");
        }

        // 6) Booth Visitors
        let resBooth = await this.generateSheet({ eventId, event_type: 'Exhibition-Area' });
        if (resBooth?.data?.data) {
          utils.book_append_sheet(wb, utils.json_to_sheet(resBooth.data.data.session_analytics), "Booth Visitors");
        }

        // 7) Event Assets Download
        let resAssets = await this.generateSheet({ eventId, event_type: 'Event-Downloads' });
        if (resAssets?.data?.data) {
          utils.book_append_sheet(wb, utils.json_to_sheet(resAssets.data.data.session_analytics), "Event Downloads");
        }

        // 8) Chat + Video Calls
        let resChat = await this.generateSheet({ eventId, event_type: 'Chats' });
        if (resChat?.data?.data) {
          utils.book_append_sheet(wb, utils.json_to_sheet(resChat.data.data.chat), "Chat Analytics");
          utils.book_append_sheet(wb, utils.json_to_sheet(resChat.data.data.video_call), "Video Calls");
        }

        // 9) Meetings
        let resMeetings = await this.generateSheet({ eventId, event_type: 'Meetings' });
        if (resMeetings?.data?.data) {
          utils.book_append_sheet(wb, utils.json_to_sheet(resMeetings.data.data.session_analytics), "Meetings Analytics");
        }

        // Export final consolidated Excel
        writeFileXLSX(wb, "Event_User_Journey_Report.xlsx");
},
async export3DDisplayCenterFile(){
    let sheet_session   = [];
    let sheet_qa        = [];
    let sheet_polling   = [];
    let sheet_rating    = []
    let postData = {eventId :this.$route.params.event_id, event_type:'DisplayCenter'}
    let response = await this.generateSheet(postData);
    if(response.data.data){
        sheet_session       = response.data.data.session_analytics;
        
    }
    /* generate worksheet from state */
     const ws = utils.json_to_sheet(sheet_session);
    
    /* create workbook and append worksheet */
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Session Analytics");
    
    /* export to XLSX */
    writeFileXLSX(wb, "3DDisplayCenter.xlsx");
}

}



}
</script>

<style lang="scss" scoped>


.report-section {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.report-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.report-table-container {
  overflow-x: auto;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  background: #fafafa;
}

.report-table th,
.report-table td {
  text-align: left;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.95rem;
}

.report-table th {
  background: #f3f4f6;
  color: #555;
  font-weight: 600;
}

.report-table tr:hover {
  background: #f9fafb;
}

.download-icon {
  font-size: 1.4rem;
  color: #007bff;
  cursor: pointer;
  transition: color 0.2s ease;
}

.download-icon:hover {
  color: #0056b3;
}

</style>
